<template>
  <div v-if="content" class="jumbotron information">
    <h2 class="title">{{ title }}</h2>
    <div class="text-left ">
      <rich-text-renderer :document="content"/>
    </div>

    <p class="text-center">
      <router-link class="btn btn-info" to="/mere">Læs mere...</router-link>
    </p>
  </div>
</template>

<script>
import {createContentfulClient} from "@/api/ContentfulClient";
import RichTextRenderer from 'contentful-rich-text-vue-renderer';

const client = createContentfulClient();

export default {
  name: "AboutSection",
  components: {
    RichTextRenderer
  },
  data() {
    return {
      title: undefined,
      content: undefined,
    }

  },
  created() {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    async fetchData() {
      this.error = this.post = null;
      this.loading = true;
      const entries = await client.getEntries({
        'content_type': 'information',
        'fields.slug': 'hvad-er-running-dinner',
        'include': 3
      });

      if (entries.total >= 1) {
        const data = entries.items[0].fields

        this.title = data.title;
        this.content = data.content;
      } else if (entries.errors) {
        await this.$router.push('/')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.jumbotron.information {
  background: rgba(14, 46, 94, 0.7);

  h2 {
    color: #f4d35e;
    text-shadow: 1px 1px 2px #ee964b;
    &.title {
      padding-top: 0;
    }
  }

  p {
    color: white;
    text-align: justify;
  }

}

</style>
